<template>
	<popupLayout>
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
		<div class="bootbox-body">
			<div class="row form-group mb-lg">
				<div class="col-md-12">
					<label class="col-md-4">打掃情形</label>
					<div class="col-md-8">
						<select v-model="situation" >
							<option value="">--請選擇--</option>
							<option value="未掃">未掃</option>
							<option value="稍髒">稍髒</option>
							<option value="尚可">尚可</option>
							<option value="乾淨">乾淨</option>
						</select>
					</div>
				</div>
			</div>
			<div class="row form-group mb-lg">
				<div class="col-md-12">
					<label class="col-md-4">照片</label>
					<div class="col-md-8">
						<label for="fileV" class="btn btn-primary">選擇檔案</label>
						<span>{{picName}}</span>
						<input id="fileV" ref="fileV" name="file" type="file" accept=".pdf,image/*" @change="uploadPic($event)" style="display: none" />
						<br/>
						<img :src="this.picPreview" style="width:200px;"/>
					</div>
					
				</div>
			</div>
			<div class="row">
				<div class="col-md-offset-4 col-md-4">
					<div class=" col-md-offset-3 col-md-6">
						<a class="btn btn-danger btn-block" @click="saveAudit">送出</a>
					</div>
				</div>
			</div>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:["id", "type"],
	data(){
		return {
			situation:"",
			picFile:null,
			picPreview:null,
			picName:"",
		};
	},
	methods:{
		closePopup() {
			this.$parent.showPopupControl(false);
		},
		uploadPic(event){
			let self = this;
			this.picFile = event.target.files[0];
			if(this.picFile != null){
				if(this.checkFileExtension(this.picFile.name, ["jpg","jpeg","png","pdf"])){
					this.picName = this.picFile.name;
					this.imgPreview(event.target.files[0]).then(result=>{
						self.picPreview = result;
					}).catch(reason =>{
						self.picFile = null;
						bootbox.alert("上傳失敗，請重新上傳。");
					});
					if (/^image/.test(this.picFile.type)){
						this.compresImage(this.picFile).then(result => {
							this.picFile = result;
						});
					}
				}
			}
		},
		saveAudit(){
			if(this.situation){
				// console.log(this.id);
				let _this = this;
				let api = "/api/Environment/saveCleanAudit";
				let formData = new FormData();
				if(this.type == "1"){
					formData.append("situation", this.situation);
					formData.append("proofFile", this.picFile);
				}else{
					formData.append("agResult", this.situation);
					formData.append("agProofFile", this.picFile);
				}
				formData.append("Id", this.id);
				
				this.$axios.post(api, formData).then(resp => {
					bootbox.alert(resp.data.msg, function(){
						if(resp.data.status == "success"){
							_this.$parent.gridInit();
							_this.$parent.showPopupControl(false);
						}
					});
				});
			}else{
				bootbox.alert("打掃情形尚未填寫。");
			}
		}
	}
}
</script>